import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-drop-down]',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
